import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  coeCard: {
    height: '190px !important',
    backgroundColor: theme.palette.KenColors.ClientGrey2,
    borderRadius: '12px',
    padding: '24px',
    cursor: 'pointer',
    [theme.breakpoints.down('ultraHD')]: {
      padding: '18px',
      borderRadius: '9px',
      height: '152px !important',
    },
  },
  cardImage: {
    display: 'flex',
    justifyContent: 'start',
    height: '36px',
    [theme.breakpoints.down('ultraHD')]: {
      height: '27px',
    },
  },
  cardHeader: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    lineHeight: '22px !important',
    textAlign: 'start',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
  cardActionContainer: {
    marginBottom: '12px!important',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('ultraHD')]: {
      marginBottom: '9px !important',
    },
  },
  cardDescription: {
    textAlign: 'start',
    fontSize: '16px !important',
    fontWeight: '400 !important',
    color: '#545454',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
  //   offerings
  offeringCardContainer: {
    height: '100%',
    backgroundColor: theme.palette.KenColors.ClientRoyalpurple50,
    padding: '24px !important',
    borderRadius: '12px',
    [theme.breakpoints.down('ultraHD')]: {
      padding: '18px !important',
      borderRadius: '9px',
    },
  },
  offeringTitleTypo: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
  offeringDescriptionTypo: {
    marginTop: '12px !important',
    fontSize: '16px !important',
    fontWeight: '400 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
      marginTop: '9px !important',
    },
  },
}));
